// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 3524 ? "app" : chunkId) + "." + {"3524":"4fb215d95dac864eee26","7287":"18823f1846a950e15fd2"}[chunkId] + ".css";
};